<template>
  <div class="ce-wrapper">
    <div v-if="editMode" :class="'ce ce-' + content.type + ' ce-edit-mode'">
      <div class="edit-header d-flex align-items-center">
        <h5 class="mb-0">
          <span class="text-success"><i class="fas fa-tasks"></i></span>
          Checklista
        </h5>
        <CeButtonGroup
          v-on:on-remove-click="onRemoveClick"
          v-on:on-arrow-up-click="onArrowUp"
          v-on:on-arrow-down-click="onArrowDown"
        />
      </div>
      <b-form-group label="Rubrik för listan" label-sr-only>
        <b-form-input
          @change="updateHeadline"
          :value="content.headline"
          :id="'ceChecklistHeadline' + content.id"
          placeholder="Rubrik för listan... (valfritt)"
        ></b-form-input>
      </b-form-group>
      <b-form
        ref="form"
        :style="{ height: trHeight }"
        class="repeater-form"
        @submit.prevent="addChecklistItem"
      >
        <!-- Row Loop -->
        <b-row
          v-for="(item, index) in content.items"
          :id="item.id"
          :key="item.id"
          ref="row"
        >
          <!-- Item Name -->
          <b-col cols="12">
            <b-form-group :label-for="item.id.toString()" class="ml-1">
              <b-input-group>
                <b-input-group-prepend is-text>
                  <input type="checkbox" aria-label="Checkbox för textruta" />
                </b-input-group-prepend>
                <b-form-input
                  :value="item.headline"
                  v-on:change.native="updateItemHeadline"
                  :id="item.id.toString()"
                  type="text"
                  :placeholder="'Skriv punkt ' + (index + 1) + ' här...'"
                />
                <b-input-group-append>
                  <b-button variant="flat-primary" @click="removeItem(item)">
                    <i class="fas fa-trash"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      <b-button
        variant="success"
        size="sm"
        class="mb-1"
        @click="addChecklistItem"
      >
        Lägg till ny punkt <i class="fas fa-plus"></i>
      </b-button>
    </div>
    <div v-else :class="'ce ce-' + content.type">
      <h3 v-if="content.headline" class="ce-headline mb-1">
        {{ content.headline }}
      </h3>
      <div class="ce-list">        
        <div v-for="item in content.items" :key="item.id" class="ce-list-item">
          <div class="ce-list-item-prefix">
            <b-form-checkbox
              name="checkbox-1"
              :checked="checkBoxValue(item.id)"
              @change="updateCheckListValue(item.id)"
              unchecked-value="todo"
              :key="checkBoxValue(item.id)"
            />
          </div>
          <div class="ce-list-item-desc">
            <h6 class="mb-0">{{ item.headline }}</h6>
          </div>
        </div>
      </div>
                  <b-button 
        variant="primary"
        size="sm"
        class="mb-1"
        @click="checkAllValues">Allt klart</b-button> <b-button 
        variant="secondary"
        size="sm"
        class="mb-1"
        @click="uncheckAllValues">Växla status</b-button>
  </div>
    </div>
</template>

<script>
import {
  BFormCheckbox,
  BForm,
  BFormGroup,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormInput,
  BRow,
  BCol,
  BButton,
} from "bootstrap-vue";
import { heightTransition } from "@core/mixins/ui/transition";
import CeButtonGroup from "@/components/Article/ContentElements/CeButtonGroup";
import ContentElementButtonGroupMixin from "@/models/mixins/ContentElementButtonGroupMixin";
import ContentElementSimpleChecklistItemMixin from "@/models/mixins/ContentElementSimpleChecklistItemMixin";
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("editArticle");

export default {
  name: "CeListChecklist",
  props: {
    content: {},
    editMode: Boolean,
  },
  computed: {},
  mixins: [
    heightTransition,
    ContentElementButtonGroupMixin,
    ContentElementSimpleChecklistItemMixin,
  ],
  methods: {
    ...mapActions([
      "updateContent",
      "addNewChecklistItem",
      "removeChecklistItem",
      "initArticleEdit",
      "clearArticleEdit",
    ]),

    updateHeadline(headline) {
      let content = this.content;
      content.headline = headline;
      this.updateContent(content);
    },
    updateItemHeadline(e) {
      if (!e.srcElement?.id || !e.srcElement?.value) {
        return;
      }

      let itemIndex = this.content.items.findIndex(
        (i) => i.id == e.srcElement.id
      );
      let content = this.content;
      content.items[itemIndex].headline = e.srcElement.value;
      this.updateContent(content);
    },
    initTrHeight() {
      if (!this.editmode) return;
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
  },
  mounted() {
    this.initTrHeight();

    if (this.content.items.length < 1) {
      for (let i = 1; i < 4; i++) {
        setTimeout(() => {
          this.addChecklistItem();
        }, 0);
      }
    }
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  components: {
    CeButtonGroup,
    BFormCheckbox,
    BForm,
    BFormGroup,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormInput,
    BRow,
    BCol,
    BButton,
  },
};
</script>
<style lang="scss" scoped>
@import "src/assets/scss/variables/_variables.scss";
.ce-wrapper {
  margin-bottom: 1rem;
}
.ce-wrapper::after {
  /* clear fix */
  display: block;
  content: "";
  clear: both;
}
.ce-edit-mode {
  padding: 0.5rem 1rem;
  border: 1px solid #d8d6de;
  border-radius: 0.428rem;
}
.ce-edit-mode:hover {
  border: 1px solid $primary;
}
.edit-header {
  // border-bottom: 1px dotted $primary;
  padding: 0.5rem 0;
  margin-bottom: 1rem;
}
.edit-header h5 {
  color: $primary;
  margin-right: auto;
}

.ce-list-item {
  display: flex;
  align-items: center;
  padding: 0.25rem;
  border-bottom: 1px solid #ebe9f1;
}
.ce-list-item:last-child {
  border-bottom: none;
}
.ce-list-item-prefix {
  padding: 0.75rem 0;
}
.ce-list-item-desc {
  padding: 0.75rem 0 0.75rem 0.75rem;
}
.ce-list-item-action {
  padding: 0.75rem 0;
  min-width: 79px;
}
.ce-list-item-desc {
  margin-right: auto;
}
</style>
